/*
 * @Author: tanyaohua
 * @Date: 2020-07-27 10:45:50
 * @LastEditTime: 2020-08-21 16:22:04
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\resourceCenter\newspaperRemark\remarkChannel\left\left.js
 * @Description: 读报评报-评报栏左侧的指令
 */ 
'use strict';
angular.module('newspaperRemarkChannelLeftModule', [])
    .directive('remarkChannelLeft', ['$state', function($state) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                selectedParent: '=',
                selectedPaper: '='
            },
            templateUrl: './resourceCenter/newspaperRemark/remarkChannel/left/left.html',
            link: function($scope, $elem, $attrs) {
                initStatus();
                initData();

                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.status = {
                        selectedType: $state.params.typetwo,
                        selected: '',
                    };
                    $scope.data = {};
                    // watchParent();
                }

                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initData() {
                    $scope.firstNav = $scope.selectedParent;
                    if ($scope.status.selectedType) {
                        $scope.status.selected = $scope.firstNav.filter((item) => item.type == $scope.status.selectedType)[0];
                        // selectLeve3($scope.status.selected);
                    } else {
                        $scope.status.selected = $scope.firstNav[0];
                        $scope.status.selectedType = $scope.status.selected.type;
                        // selectLeve3($scope.status.selected);
                    }
                }

                /**
                 * [selectLeve3 description] 选中三级节点
                 * @param  {[type]} item      [description] 点击事件
                 * @param  {[type]} obj        [description] 所点选项
                 * @param  {[type]} parentItem [description] 父选项
                 * @return {[type]}            [description]
                 */
                $scope.selectLeve3 = function (item) {
                    $state.params.typetwo = item.type || 'sd';
                    $state.params.change = Math.random(0, 1) * 100;
                    $state.transitionTo($state.current, $state.params, {
                        reload: false
                    });
                    $state.reload($state.current);
                    // messagePublishService.publish('requestPaperList', $scope.selectedPaper); // 本模块的路由比较简单，只做了左侧导航跟右侧列表的分层，使用消息机制在左侧请求到报纸信息后通知右侧列表请求页面
                    // resourceCenterService.go('newspaperRemark', {
                    //     paperid: '154',
                    //     type: 'pbl',
                    //     typetwo:item.type,
                    //     change: Math.random(0, 1) * 100,
                    // });
                    $scope.status.selected = item;
                    $scope.status.selectedType = item.type;
                    // messagePublishService.publish('routerToNewspaperRemarkList', 'true');
                };
                
            }
        };
    }]);
